/**
 * MenuItemsEditor — admin list of orderable items for an event. Each item has a
 * name, optional description, price, and max-qty cap. Items are entered manually
 * per event (v1 scope).
 */
import React from 'react';
import { newItem } from '../eventUtils';

export default function MenuItemsEditor({ items, onChange }) {
  const patch = (id, p) => onChange(items.map((it) => (it.id === id ? { ...it, ...p } : it)));
  const remove = (id) => onChange(items.filter((it) => it.id !== id));
  const add = () => onChange([...items, newItem()]);
  const move = (id, dir) => {
    const idx = items.findIndex((i) => i.id === id);
    const j = idx + dir;
    if (j < 0 || j >= items.length) return;
    const next = [...items];
    [next[idx], next[j]] = [next[j], next[idx]];
    onChange(next);
  };

  return (
    <div className="ev-items">
      {items.length === 0 && (
        <p className="ev-empty-sm">No items yet — add the dishes and drinks people can pre-order.</p>
      )}
      {items.map((it, i) => (
        <div key={it.id} className="ev-itemcard">
          <div className="ev-itemcard__main">
            <input className="ev-input" placeholder="Item name (e.g. Chicken Biryani)"
              value={it.name} onChange={(e) => patch(it.id, { name: e.target.value })} />
            <input className="ev-input" placeholder="Short description (optional)"
              value={it.description} onChange={(e) => patch(it.id, { description: e.target.value })} />
          </div>
          <div className="ev-itemcard__meta">
            <label className="ev-minifield">
              <span>Price</span>
              <input className="ev-input ev-input--sm" type="number" min="0" placeholder="0"
                value={it.price} onChange={(e) => patch(it.id, { price: e.target.value })} />
            </label>
            <label className="ev-minifield">
              <span>Max qty</span>
              <input className="ev-input ev-input--sm" type="number" min="1" placeholder="∞"
                value={it.maxQty} onChange={(e) => patch(it.id, { maxQty: e.target.value })} />
            </label>
            <div className="ev-itemcard__actions">
              <button className="ev-iconbtn" disabled={i === 0} onClick={() => move(it.id, -1)} title="Move up">↑</button>
              <button className="ev-iconbtn" disabled={i === items.length - 1} onClick={() => move(it.id, 1)} title="Move down">↓</button>
              <button className="ev-iconbtn ev-iconbtn--danger" onClick={() => remove(it.id)} title="Remove">✕</button>
            </div>
          </div>
        </div>
      ))}
      <button className="ev-addbtn" onClick={add}>+ Add item</button>
    </div>
  );
}
